document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.element-favorite').forEach(
  /**
   * @param {HTMLBaseElement} favorite
   */
  (favorite) => {
    favorite.addEventListener('click', () => {
      if (favorite.classList.contains('active')) {
        favorite.classList.remove('active');
      } else {
        favorite.classList.add('active');
      }
    });
  });
});
